import React, { ReactNode } from "react";
import { Button } from "capitalrx-components";
import classNames from "classnames";

export interface ButtonType {
  className: string;
  handleClick?: (event: React.MouseEvent) => void;
  selected: boolean;
  content: ReactNode;
  buttonType?: "link" | "router-link";
  action?: string;
}

interface Props {
  buttons: Array<ButtonType>;
}

const ButtonArray: React.FC<Props> = (props: Props) => {
  const { buttons } = props;

  return (
    <div className="tab-header">
      {buttons.map(({ className, handleClick, selected, content, buttonType, action }, index) => {
        const tabClassNames = classNames("tab-header-button", className, {
          "tab-header-button-selected": selected,
        });

        return (
          <Button
            key={index}
            extraClasses={tabClassNames}
            buttonType={buttonType}
            buttonStyle="outline"
            color="lightgrey-700"
            handleClick={handleClick}
            path={action}
          >
            {content}
          </Button>
        );
      })}
    </div>
  );
};

export default ButtonArray;
